import { render, staticRenderFns } from "./CompanySettingsDialog.vue?vue&type=template&id=0d8af9d1"
import script from "./CompanySettingsDialog.vue?vue&type=script&lang=js"
export * from "./CompanySettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsDialog.vue?vue&type=style&index=0&id=0d8af9d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports